import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Option } from "../../types/commonElements";
import {
  modeOfPaymentOptions,
  paymentTypeOptions,
} from "../../config/constants/options";
import { FormData, PaymentState } from "../../types/paymentTypes";

const initialState: PaymentState = {
  formData: {
    amount: "",
    modeOfPayment: "",
    paymentReferenceNo: "",
    paymentType: "",
    focReason: "",
    paymentStatus: "",
    isGstCollected: false,
    isInvoiceAvailable: false,
  },
  errors: {},
  selectOptions: {
    paymentType: paymentTypeOptions,
    modeOfPayment: modeOfPaymentOptions,
  },
};

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    setFormData: (state, action: PayloadAction<FormData>) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    setSelectOptions: (
      state,
      action: PayloadAction<{ [key: string]: Option[] }>
    ) => {
      state.selectOptions = action.payload;
    },
    setErrors: (state, action: PayloadAction<Record<string, string>>) => {
      state.errors = action.payload;
    },
    clearErrors: (state) => {
      state.errors = {};
    },
    clearForm: (state) => {
      state.formData = {
        ...initialState.formData,
        isInvoiceAvailable: state.formData.isInvoiceAvailable,
      };
      state.selectOptions = initialState.selectOptions;
      state.errors = {};
    },
  },
});

export const {
  setFormData,
  setErrors,
  clearErrors,
  clearForm,
  setSelectOptions,
} = paymentSlice.actions;

export default paymentSlice.reducer;
